import React from 'react';
const UserAgentContext = React.createContext(false);
export default UserAgentContext;
